import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  TextField,
  useTheme,
  InputAdornment,
  Button,
  Paper,
  IconButton,
} from "@mui/material";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import SearchIcon from "@mui/icons-material/Search";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardHeader from "../Dashboard/DashboardHeader";
import { baseapi } from "../Environmentalurl";
import {
  entity_id,
  orderID,
  payuPayment,
  returnurl,
  Platform,
  date,
  locationGeo,
  ApplicationType,
} from "../Utils/Const";
import api from "../Utils/Api";
import useIPAddress from "../Utils/useIPAddress";

// ✅ Bank Logo Map using Google Favicon Service
const BANK_LOGOS = {
  SBIB:     "https://www.google.com/s2/favicons?sz=64&domain=onlinesbi.sbi",
  ICIB:     "https://www.google.com/s2/favicons?sz=64&domain=icicibank.com",
  PNBB:     "https://www.google.com/s2/favicons?sz=64&domain=netpnb.com",
  CABB:     "https://www.google.com/s2/favicons?sz=64&domain=canarabank.in",
  INDB:     "https://www.google.com/s2/favicons?sz=64&domain=indianbank.in",
  UCOB:     "https://www.google.com/s2/favicons?sz=64&domain=ucobank.com",
  FEDB:     "https://www.google.com/s2/favicons?sz=64&domain=federalbank.co.in",
  INIB:     "https://www.google.com/s2/favicons?sz=64&domain=indusind.com",
  YESB:     "https://www.google.com/s2/favicons?sz=64&domain=yesbank.in",
  IDBB:     "https://www.google.com/s2/favicons?sz=64&domain=idbibank.in",
  IDFCNB:   "https://www.google.com/s2/favicons?sz=64&domain=idfcfirstbank.com",
  RBLNB:    "https://www.google.com/s2/favicons?sz=64&domain=rblbank.com",
  DCBB:     "https://www.google.com/s2/favicons?sz=64&domain=dcbbank.com",
  KRKB:     "https://www.google.com/s2/favicons?sz=64&domain=karnatakabank.com",
  CUBB:     "https://www.google.com/s2/favicons?sz=64&domain=cityunionbank.com",
  KRVB:     "https://www.google.com/s2/favicons?sz=64&domain=kvb.co.in",
  KRVBC:    "https://www.google.com/s2/favicons?sz=64&domain=kvb.co.in",
  CBIB:     "https://www.google.com/s2/favicons?sz=64&domain=centralbankofindia.co.in",
  INOB:     "https://www.google.com/s2/favicons?sz=64&domain=iob.in",
  BOIB:     "https://www.google.com/s2/favicons?sz=64&domain=bankofindia.co.in",
  BOMB:     "https://www.google.com/s2/favicons?sz=64&domain=bankofmaharashtra.in",
  JAKB:     "https://www.google.com/s2/favicons?sz=64&domain=jkbank.com",
  SOIB:     "https://www.google.com/s2/favicons?sz=64&domain=southindianbank.com",
  TMBB:     "https://www.google.com/s2/favicons?sz=64&domain=tmb.in",
  CSBN:     "https://www.google.com/s2/favicons?sz=64&domain=csb.co.in",
  DLSB:     "https://www.google.com/s2/favicons?sz=64&domain=dhanbank.com",
  SRSWT:    "https://www.google.com/s2/favicons?sz=64&domain=saraswatbank.com",
  SVCNB:    "https://www.google.com/s2/favicons?sz=64&domain=svcbank.com",
  CSMSNB:   "https://www.google.com/s2/favicons?sz=64&domain=cosmosbank.com",
  UNIB:     "https://www.google.com/s2/favicons?sz=64&domain=pnbindia.in",
  OBCB:     "https://www.google.com/s2/favicons?sz=64&domain=pnbindia.in",
  CPNB:     "https://www.google.com/s2/favicons?sz=64&domain=pnbindia.in",
  PSBNB:    "https://www.google.com/s2/favicons?sz=64&domain=punjabandsindbank.co.in",
  SYNDB:    "https://www.google.com/s2/favicons?sz=64&domain=canarabank.in",
  DSHB:     "https://www.google.com/s2/favicons?sz=64&domain=db.com",
  IDBICORP: "https://www.google.com/s2/favicons?sz=64&domain=idbibank.in",
  AUSFCNB:  "https://www.google.com/s2/favicons?sz=64&domain=aubank.in",
  CSFBR:    "https://www.google.com/s2/favicons?sz=64&domain=capitalbank.co.in",
  PHONEPE:  "https://www.google.com/s2/favicons?sz=64&domain=phonepe.com",
  AMZPAY:   "https://www.google.com/s2/favicons?sz=64&domain=amazon.in",
  OLAM:     "https://www.google.com/s2/favicons?sz=64&domain=olamoney.com",
  MOBIKWIK: "https://www.google.com/s2/favicons?sz=64&domain=mobikwik.com",
};

// ✅ Helper to generate a unique Order ID for retries on duplicate order errors
const generateOrderId = () => {
  const timestamp = Date.now().toString();
  const random = Math.floor(100 + Math.random() * 900); // 3-digit suffix
  return `${timestamp}${random}`;
};



export default function Loadusingnetbanking() {
  const theme = useTheme();
  const ip = useIPAddress();
  const isDark = theme.palette.mode === "dark";

  const pageBg      = isDark ? "#0B1321" : "#f3f5f8";
  const cardBg      = isDark ? "#0F1C2E" : "#ffffff";
  const inputBg     = isDark ? "#0D1729" : "#f2f4f6";
  const textColor   = isDark ? "#ffffff" : "#0e1b2c";
  const subText     = isDark ? "#9aaac1" : "#6b7587";
  const borderColor = isDark
    ? "1px solid rgba(90,126,173,0.45)"
    : "1px solid rgba(0,0,0,0.12)";

  const location = useLocation();

  // ✅ Read amount from LoadMoney page — not editable
  const [amount] = useState(location.state?.amount || "");

  const [loading, setLoading]           = useState(false);
  const [banks, setBanks]               = useState([]);
  const [search, setSearch]             = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [payUKey, setPayUKey]           = useState("");
  const [payUHash, setPayUHash]         = useState("");
  const [user, setUser]                 = useState({});

  // ✅ Track the active order ID separately, since it may change on retries
  const [activeOrderId, setActiveOrderId] = useState(orderID);

  const navigate = useNavigate();

  const sessionData = {
    SessionID:   sessionStorage.getItem("SessionID"),
    Mobilenumber: sessionStorage.getItem("mobileNumber"),
    Name:        sessionStorage.getItem("NameOnCard")?.replace(/"/g, ""),
    email:       sessionStorage.getItem("Poiemail")?.replace(/"/g, ""),
    EntityID:    entity_id,
    MachineID:   ip,
    GeoLocation: locationGeo,
  };

  // ── Fetch Bank List ──────────────────────────────────────────────────────
  useEffect(() => {
    async function fetchBanks() {
      try {
        const response = await api.post(`${baseapi}/activenetbankslist`, {
          ReqType:      "TA_PayU_ActiveNetBanksList",
          GeoLocation:  locationGeo,
          Platform:     Platform,
          MachineID:    ip,
          EntityID:     entity_id,
          SessionID:    sessionData.SessionID,
          Mobilenumber: sessionData.Mobilenumber,
          Date:         date,
        });
        if (response.data.Response_Code === "2980") {
          setBanks(response.data.Info);
        }
      } catch (error) {
        console.error("Bank list API error:", error);
      }
    }
    fetchBanks();
  }, []);

  // ── Initialize Payment when Bank Selected ────────────────────────────────
  useEffect(() => {
    const initializePayment = async (currentOrderId, attempt = 0) => {
      if (!selectedBank) return;

      const MAX_ATTEMPTS = 5;

      try {
        setLoading(true);
        const res = await api.post(`${baseapi}/tapayuinsertnetbank`, {
          ReqType:      "TA_PayU_PGInsertLog",
          Mobilenumber: sessionData.Mobilenumber,
          SessionID:    sessionData.SessionID,
          Amount:       amount,
          HashString:   `${currentOrderId}|${amount}|LoadMoney|${sessionData.Name}|${sessionData.email}|||||||||||`,
          Date:         date,
          MachineID:    ip,
          Platform:     Platform,
          EntityID:     entity_id,
          OrderId:      currentOrderId,
          GeoLocation:  locationGeo,
        });

        if (res.data.Response_Code === "2610") {
          // ✅ Success — store the working order ID and PayU credentials
          setPayUKey(res.data.Key);
          setPayUHash(res.data.HashString);
          setActiveOrderId(currentOrderId);
        } else if (res.data.Response_Code === "46012") {
          // ✅ OrderID already exists — retry with a new order ID
          if (attempt < MAX_ATTEMPTS) {
            const newOrderId = generateOrderId();
            console.warn(
              `OrderID ${currentOrderId} already exists. Retrying with ${newOrderId} (attempt ${attempt + 1})`
            );
            await initializePayment(newOrderId, attempt + 1);
            return; // prevent setLoading(false) from running before the retry finishes
          } else {
            alert("Unable to initialize payment. Please try again.");
          }
        } else {
          alert(res.data.Message || "InsertLog failed.");
        }
      } catch (err) {
        console.error(err);
      } finally {
        // Only stop loading when not in the middle of a retry
        if (attempt === 0 || true) {
          setLoading(false);
        }
      }
    };

    if (selectedBank) {
      initializePayment(generateOrderId());
    }
  }, [selectedBank]);

  // ── Balance Enquiry ──────────────────────────────────────────────────────
  useEffect(() => {
    const fetchBalanceEnquiry = async () => {
      try {
        const payload = {
          ApplicationType: ApplicationType,
          EntityID:        entity_id,
          GeoLocation:     locationGeo,
          MachineID:       ip,
          Mobilenumber:    sessionStorage.getItem("mobileNumber"),
          Platform:        Platform,
          ReqType:         "Jan_Aadhaar_eWallet_Balance_Enquiry",
          SessionID:       sessionStorage.getItem("SessionID") || "",
        };
        const response = await api.post(
          `${baseapi}/JanAadhaareWalletBalanceEnquiry`,
          payload
        );
        if (response.data.Response_Code === "1000") {
          setUser((prev) => ({
            ...prev,
            Balance:       response.data.Balance,
            LedgerBalance: response.data.LedgerBalance,
            NameOnCard:    prev.NameOnCard || "User Name",
            UPIVPA:        prev.UPIVPA || "user@upi",
            Is_KYC_Done:   prev.Is_KYC_Done || "1",
          }));
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };
    fetchBalanceEnquiry();
  }, [location.search]);

  const filteredBanks  = banks.filter((bank) =>
    bank.BankName.toLowerCase().includes(search.toLowerCase())
  );

  const handlenavigate = () => navigate("/dashboard/loadmoney");

  // ── Proceed to Pay ───────────────────────────────────────────────────────
  const handleProceedToPay = async () => {
    if (!selectedBank)          { alert("Please select a bank.");               return; }
    if (!amount || Number(amount) < 10) { alert("Please enter valid amount."); return; }
    if (!payUKey || !payUHash)  { alert("Payment not initialized. Try again."); return; }

    setLoading(true);

    setTimeout(() => {
      const form   = document.createElement("form");
      form.method  = "POST";
      form.action  = payuPayment;

      const params = {
        udf2: "", zipcode: "", lastname: sessionData.Name,
        ccexpyr: "", productinfo: "LoadMoney", store_card_token: "",
        ccvv: "", address1: "", pg: "NB", udf1: "",
        key: payUKey, email: sessionData.email,
        user_credentials: payUKey, firstname: sessionData.Name,
        ccname: "", country: "", bankcode: selectedBank,
        store_card: "", udf5: "", txnid: activeOrderId,
        ccexpmon: "", hash: payUHash, udf4: "",
        state: "", surl: returnurl, city: "", udf3: "",
        amount: amount, address2: "", curl: returnurl,
        furl: returnurl, ccnum: "", phone: sessionData.Mobilenumber,
      };

      console.log("Submitting Form Data:", params);

      Object.entries(params).forEach(([key, value]) => {
        const input   = document.createElement("input");
        input.type    = "hidden";
        input.name    = key;
        input.value   = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    }, 10000);
  };

  // ── UI ───────────────────────────────────────────────────────────────────
  return (
    <>
      <Box px={7} bgcolor={isDark ? "#0d1828" : ""}>
        <DashboardHeader />
      </Box>

      <Box
        sx={{
          p: { xs: 2, md: 4 },
          backgroundColor: isDark ? "#0B1321" : "#f3f5f8",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 1100,
            borderRadius: 4,
            backgroundColor: isDark ? "#0F1C2E" : "#fff",
            p: { xs: 2, md: 4 },
            border: isDark
              ? "1px solid rgba(90,126,173,0.45)"
              : "1px solid rgba(0,0,0,0.12)",
          }}
        >
          {/* HEADER */}
          <Box display="flex" gap={1} alignItems="center" mb={3}>
            <IconButton onClick={handlenavigate}>
              <ArrowBackIosNewOutlinedIcon sx={{ color: textColor }} />
            </IconButton>
            <Typography sx={{ color: textColor, fontWeight: 500 }}>
              BACK
            </Typography>
          </Box>

          <Grid container spacing={6}>
            {/* ── LEFT SIDE ── */}
            <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
              <Typography variant="h6" sx={{ color: textColor, fontWeight: 700 }}>
                Wallet Balance: <span>₹{user?.Balance}</span>
              </Typography>

              <Typography sx={{ mt: 3, color: textColor }}>Amount</Typography>

              {/* ✅ Read-only amount */}
              <TextField
                fullWidth
                value={amount}
                placeholder="10"
                sx={{
                  mt: 1,
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: inputBg,
                    height: 55,
                    borderRadius: 2,
                    "& fieldset": { border: "none" },
                  },
                  "& input": {
                    cursor: "default",
                    pointerEvents: "none",
                    fontWeight: 700,
                    fontSize: 22,
                    color: textColor,
                  },
                }}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography sx={{ fontSize: 22, color: textColor, fontWeight: 700 }}>
                        ₹
                      </Typography>
                    </InputAdornment>
                  ),
                }}
              />

              {/* NOTES */}
              <Paper
                sx={{
                  mt: 4,
                  p: 3,
                  backgroundColor: isDark ? "#0B1C30" : "#eef1f5",
                  borderRadius: 3,
                }}
              >
                <Typography sx={{ color: textColor, fontWeight: 600 }}>Note:</Typography>
                <Typography sx={{ color: subText, mt: 1 }}>
                  1. Minimum Load Money amount is Rs.10/-.
                  <br />
                  2. Do not use wallets or virtual cards.
                  <br />
                  3. If debited and not credited, wait 2 working days.
                </Typography>
              </Paper>
            </Grid>

            {/* ── RIGHT SIDE ── */}
            <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
              <Typography sx={{ color: textColor, fontWeight: 700, mb: 2 }}>
                Choose Your Bank
              </Typography>

              {/* Search */}
              <TextField
                fullWidth
                placeholder="Search your bank"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: inputBg,
                    height: 46,
                    borderRadius: 2,
                    "& fieldset": { border: "none" },
                    color: textColor,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: subText }} />
                    </InputAdornment>
                  ),
                }}
              />

              {/* Scrollable Bank List */}
              <Box
                sx={{
                  height: 300,
                  borderRadius: 3,
                  border: borderColor,
                  backgroundColor: isDark ? "#0B1C30" : "#f8fafc",
                  p: 2,
                  overflowY: "auto",
                  "&::-webkit-scrollbar": { width: 6 },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#cbd5e1",
                    borderRadius: 3,
                  },
                }}
              >
                <Grid container spacing={2}>
                  {filteredBanks.length > 0 ? (
                    filteredBanks.map((bank, index) => (
                      <Grid item xs={6} sm={4} key={index}>
                        <Box
                          onClick={() => setSelectedBank(bank.ibibo_code)}
                          sx={{
                            height: 120,
                            borderRadius: 2.5,
                            cursor: "pointer",
                            backgroundColor: isDark ? "#11243A" : "#ffffff",
                            border:
                              selectedBank === bank.ibibo_code
                                ? "2px solid #4db64d"
                                : "1px solid rgba(0,0,0,0.12)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s ease",
                            p: 1,
                            "&:hover": {
                              border: "2px solid #4db64d",
                              transform: "translateY(-2px)",
                            },
                          }}
                        >
                          {/* ✅ Bank Logo */}
                          <Box
                            sx={{
                              width: 46,
                              height: 46,
                              borderRadius: "50%",
                              backgroundColor: "#ffffff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              overflow: "hidden",
                              border: "1px solid rgba(0,0,0,0.08)",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                            }}
                          >
                            {BANK_LOGOS[bank.ibibo_code] ? (
                              <img
                                src={BANK_LOGOS[bank.ibibo_code]}
                                alt={bank.BankName}
                                style={{
                                  width: 30,
                                  height: 30,
                                  objectFit: "contain",
                                }}
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  e.target.parentNode.innerHTML = `<span style="font-size:10px;font-weight:700;color:#333;text-align:center;padding:2px">${bank.ibibo_code}</span>`;
                                }}
                              />
                            ) : (
                              <Typography
                                sx={{
                                  fontSize: 10,
                                  fontWeight: 700,
                                  color: textColor,
                                  textAlign: "center",
                                  px: 0.5,
                                }}
                              >
                                {bank.ibibo_code}
                              </Typography>
                            )}
                          </Box>

                          {/* Bank Name */}
                          <Typography
                            sx={{
                              mt: 1,
                              fontSize: 11,
                              fontWeight: 500,
                              color: textColor,
                              textAlign: "center",
                              px: 1,
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              lineHeight: 1.3,
                            }}
                          >
                            {bank.BankName}
                          </Typography>
                        </Box>
                      </Grid>
                    ))
                  ) : (
                    <Box width="100%" textAlign="center" mt={4}>
                      <Typography sx={{ color: subText, fontSize: 14 }}>
                        No banks found
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Box>

              {/* Secure */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mt: 2,
                  color: subText,
                }}
              >
                <LockOutlinedIcon fontSize="small" />
                <Typography sx={{ fontSize: 13 }}>
                  Secure Banking powered by PayU
                </Typography>
              </Box>

              {/* Proceed Button */}
              <Button
                fullWidth
                onClick={handleProceedToPay}
                disabled={loading}
                sx={{
                  mt: 3,
                  py: 1.3,
                  backgroundColor: "#4db64d",
                  color: "white",
                  fontWeight: 700,
                  borderRadius: 2,
                  textTransform: "none",
                  fontSize: 16,
                  "&:hover": { backgroundColor: "#45a946" },
                  "&.Mui-disabled": {
                    backgroundColor: "#4db64d",
                    color: "#fff",
                    opacity: 0.7,
                  },
                }}
              >
                {loading ? "Redirecting to Bank..." : `Proceed to Pay ₹${amount}`}
              </Button>
            </Grid>
          </Grid>
        </Card>
      </Box>
    </>
  );
}